export default {
	messages: {
		de: {
			date: 'Datum',
			time: 'Zeit',
		},
		en: {
			date: 'Date',
			time: 'Time',
		},
	},
};
